<template>
  <div class="edit-machine">

    <machine-form v-if="machine" :machine="machine" @submitted="back" />

  </div>
</template>

<script>
import MachineForm from '@/components/MachineForm'
export default {
  name: 'EditMachine',
  components: {
    MachineForm
  },
  data () {
    return {
      machineId: null,
      machine: null
    }
  },
  watch: {
    machineId () {
      this.$firestore.collection('machines')
        .doc(this.machineId)
        .get()
        .then(doc => {
          this.machine = this.$utils.docToObj(doc)
        })
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.machineId = to.params.id
    next()
  },
  created () {
    this.machineId = this.$route.params.id
  },
  methods: {
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>

</style>
